import * as React from 'react';
import { StyledMainContent } from './MainContent.styled';

export const MainContent: React.FC = props => {
	return <StyledMainContent>{props.children}</StyledMainContent>;
};
